/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { BigCommerceConfig } from "./BigCommerceConfig";
import {
  BigCommerceConfigFromJSON,
  BigCommerceConfigFromJSONTyped,
  BigCommerceConfigToJSON,
  BigCommerceConfigToJSONTyped,
} from "./BigCommerceConfig";
import type { MaskedCompanyIntegration } from "./MaskedCompanyIntegration";
import {
  MaskedCompanyIntegrationFromJSON,
  MaskedCompanyIntegrationFromJSONTyped,
  MaskedCompanyIntegrationToJSON,
  MaskedCompanyIntegrationToJSONTyped,
} from "./MaskedCompanyIntegration";

/**
 *
 * @export
 * @interface IntegrationBigCommerce
 */
export interface IntegrationBigCommerce {
  /**
   *
   * @type {MaskedCompanyIntegration}
   * @memberof IntegrationBigCommerce
   */
  integration: MaskedCompanyIntegration;
  /**
   *
   * @type {BigCommerceConfig}
   * @memberof IntegrationBigCommerce
   */
  config: BigCommerceConfig;
}

/**
 * Check if a given object implements the IntegrationBigCommerce interface.
 */
export function instanceOfIntegrationBigCommerce(
  value: object,
): value is IntegrationBigCommerce {
  if (!("integration" in value) || value["integration"] === undefined)
    return false;
  if (!("config" in value) || value["config"] === undefined) return false;
  return true;
}

export function IntegrationBigCommerceFromJSON(
  json: any,
): IntegrationBigCommerce {
  return IntegrationBigCommerceFromJSONTyped(json, false);
}

export function IntegrationBigCommerceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): IntegrationBigCommerce {
  if (json == null) {
    return json;
  }
  return {
    integration: MaskedCompanyIntegrationFromJSON(json["integration"]),
    config: BigCommerceConfigFromJSON(json["config"]),
  };
}

export function IntegrationBigCommerceToJSON(
  json: any,
): IntegrationBigCommerce {
  return IntegrationBigCommerceToJSONTyped(json, false);
}

export function IntegrationBigCommerceToJSONTyped(
  value?: IntegrationBigCommerce | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    integration: MaskedCompanyIntegrationToJSON(value["integration"]),
    config: BigCommerceConfigToJSON(value["config"]),
  };
}
